import { render, staticRenderFns } from "./DsnHelpItem.vue?vue&type=template&id=608f6cd2&"
import script from "./DsnHelpItem.vue?vue&type=script&lang=js&"
export * from "./DsnHelpItem.vue?vue&type=script&lang=js&"
import style0 from "./DsnHelpItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports